import styled from "styled-components";


export const StyledEditPromoCodeModalContent = styled.div`
  .form {
    display: flex;
    padding-bottom: 1.5rem;
    flex-direction: column;
    gap: 1rem;
  }

  .form-field {
    display: flex;
    flex-direction: column;
  }

  .date-range-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--mantine-color-gray-3);
  }

  /* Custom focus borders using primary color */
  .mantine-TextInput-input:focus,
  .mantine-NumberInput-input:focus,
  .mantine-DateInput-input:focus,
  .mantine-Select-input:focus {
    border-color: var(--clr-primary-400) !important;
  }
`;
